// Lightweight utility to track affiliate link clicks from any page
// Sends to /api/save-submission?action=conversion

import { getOrCreateUID } from './personalization';

export function trackConversion({ giftTitle, giftPrice, giftPosition, clickSource }) {
  const sessionId = sessionStorage.getItem('pickify_session_id');
  if (!sessionId) return;

  fetch('/api/save-submission?action=conversion', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sessionId,
      uid: getOrCreateUID(),
      giftTitle: giftTitle || 'Unknown',
      giftPrice: giftPrice || 0,
      giftPosition: giftPosition || 0,
      clickSource,
    }),
  }).catch(() => {}); // fire-and-forget
}
